// src/api/adminDashboard.ts
import axios from './axios';

export interface TodaySummary {
  total: number;
  reserved: number;
  completed: number;
  canceled: number;
  expired: number;
}

export interface NextReservation {
  id: number;
  service: string | null;
  date: string; // YYYY-MM-DD
  time: string; // HH:MM
  user_name?: string | null;
  doctor_name?: string | null;
  zoom_start_url?: string | null;
  zoom_join_url?: string | null;
  zoom_meeting_id?: string | null;
}

/** 今日概要 */
export async function fetchTodaySummary(): Promise<TodaySummary> {
  const res = await axios.get('/admin/dashboard/today-summary');
  return res.data;
}

/** 今日これからの最も近い予約 */
export async function fetchNextReservation(): Promise<NextReservation | null> {
  const res = await axios.get('/admin/dashboard/next');
  return res.data ?? null;
}
